import React, { FunctionComponent, useContext } from 'react'
import {observer} from 'mobx-react'
import cx from 'classnames'
import snakeCase from 'lodash.snakecase'
import SchemerModel from '../../core/SchemerModel'
import {CellValue} from './CellValue'
import {HeaderValue} from './HeaderValue'
// import {trace} from 'mobx'
import {TableStore, TableStoreContext} from './TableStore'

export interface CellProps {
  isColHeader?: boolean
  columnKey: string
  row: SchemerModel //|ColumnsConfig
  sortField?: string
  sortDir?: 'asc'|'desc'
  onChangeSort?: (newSortField: string, newSortDir: 'asc'|'desc') => void
}


export const Cell: FunctionComponent<CellProps> = observer((props) => {
  const {
    isColHeader,
    columnKey,
    row,
    sortField,
    sortDir,
    onChangeSort
  } = props
  const tableStore: TableStore = useContext(TableStoreContext)

  if (
    !tableStore
    || !tableStore.data
    || !tableStore.tableMetrics
  ) {
    return null
  }

  const {
    columnMetrics,
    numColumns,
    totalStickyWidth
  } = tableStore.tableMetrics
  const [
    ,
    colIndex,
    colWidth,
    colOffsetLeft,
    isStickyCol,
    stickyColOffsetLeft
  ] = columnMetrics[columnKey] 
  let isStickiedLeft = false
  let isStickiedRight = false

  // Only observe `visibleCells` if this is a sticky cell,
  // non-sticky cells do not need the performance overhead 
  // of responding to `visibleCells`, which updates along
  // with `scrollTop` and `scrollLeft`
  if (isStickyCol && tableStore.visibleCells) {
    const {
      stuckLeftCols,
      stuckRightCols
    } = tableStore.visibleCells
    isStickiedLeft = stuckLeftCols.includes(columnKey)
    isStickiedRight = stuckRightCols.includes(columnKey)
  }
  const isStuck = isStickiedLeft || isStickiedRight

  return (
    <div 
      className={cx(
        `sch_cell`,
        `col_${snakeCase(columnKey)}`,
        {
          col_header: isColHeader,
          is_sticky: isStickyCol,
          is_stuck: isStuck,
          is_stuck_left: isStickiedLeft,
          is_stuck_right: isStickiedRight
        }
      )}
      style={{
        width: colWidth,
        left: isStickiedLeft ? stickyColOffsetLeft : isStickiedRight ? (tableStore.dims.width - totalStickyWidth + stickyColOffsetLeft) : colOffsetLeft,
        zIndex: isStickiedLeft ? colIndex + 1 : isStickiedRight ? numColumns - (colIndex + 1) : 0
      }}
    >
      {isColHeader ? (
        <HeaderValue
          columnKey={columnKey}
          row={row}
          // width={colWidth}
          isTopLevel
          isStickyCol={isStickyCol}
          sortField={sortField}
          sortDir={sortDir}
          onChangeSort={onChangeSort}
        />
      ) : (
        <CellValue
          columnKey={columnKey}
          // width={colWidth}
          row={row}
        />
      )}
    </div>
  )
})